export default "__VITE_ASSET__CRwqmeQ5__"